/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import o from"../../core/Error.js";import r from"../CIMSymbol.js";import{symbolToCIM as t}from"../cim/CIMSymbolHelper.js";function m(m){const e=t(m);if(!e)throw new o("cimConversionUtils.convertToCIMSymbol","Unable to convert this symbol to CIM");return new r({data:e})}export{m as convertToCIMSymbol};
